import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { useSite } from "../context/SiteContext";

export function FloatingWa() {
  const { wa, content } = useSite();
  const [showTip, setShowTip] = useState(true);

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex items-center gap-3">
      <AnimatePresence>
        {showTip && (
          <motion.div
            initial={{ opacity: 0, x: 16 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 16 }}
            transition={{ delay: 2, duration: 0.5 }}
            className="hidden sm:flex items-center gap-2 glass-card rounded-sm pl-4 pr-2 py-2.5"
            data-testid="wa-tooltip"
          >
            <span className="text-xs text-frost">
              <span className="text-emerald-400 font-semibold">Online:</span> Konsultasi gratis
            </span>
            <button onClick={() => setShowTip(false)} aria-label="Tutup" className="text-steel hover:text-frost" data-testid="wa-tooltip-close">
              <X className="w-3.5 h-3.5" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.a
        data-testid="floating-whatsapp-btn"
        href={wa(content?.settings?.wa_message)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat WhatsApp"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center animate-wa-pulse"
      >
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
      </motion.a>
    </div>
  );
}
